// Admin-managed interests ("points en commun") with 4-language labels.
export const FALLBACK_INTERESTS = [
  "prayer", "worship", "bible-study", "youth", "family", "music",
  "evangelism", "missions", "sports", "cooking", "reading", "arts",
  "tech", "entrepreneurship", "volunteering", "theology",
];

export const interestOptions = (config, lang) => {
  const list = config?.interests;
  if (list?.length) return list.map((i) => ({ key: i.key, label: i.labels?.[lang] || i.labels?.fr || i.key }));
  return FALLBACK_INTERESTS.map((k) => ({ key: k, label: k }));
};

export const interestLabel = (config, lang, key) => {
  const i = (config?.interests || []).find((x) => x.key === key);
  return i ? (i.labels?.[lang] || i.labels?.fr || key) : key;
};
